import { render, staticRenderFns } from "./MppUser.vue?vue&type=template&id=4f2e408c&scoped=true"
import script from "./MppUser.vue?vue&type=script&lang=js"
export * from "./MppUser.vue?vue&type=script&lang=js"
import style0 from "./MppUser.vue?vue&type=style&index=0&id=4f2e408c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2e408c",
  null
  
)

export default component.exports